// mds-dojo — dijit/BackgroundIframe — port of references/dijit/BackgroundIframe.js.
// Real dijit only creates the shim <iframe> (to cover native <select>/ActiveX that
// ignore z-index) under old IE / quirks. The migration targets evergreen browsers
// where has("ie")/has("quirks") are false, so the constructor is a no-op and
// destroy()/resize() do nothing — exactly dojo's evergreen behavior. Kept as a real
// class so popup's `new BackgroundIframe(node)` + `.destroy()` calls work unchanged.
function BackgroundIframe(this: any, _node?: any) {
  // evergreen: no backing iframe needed
  this.iframe = null;
}

BackgroundIframe.prototype.resize = function () { /* no-op on evergreen */ };

BackgroundIframe.prototype.destroy = function () {
  if (this.iframe) {
    if (this.iframe.parentNode) { this.iframe.parentNode.removeChild(this.iframe); }
    delete this.iframe;
  }
};

export default BackgroundIframe;
